/**
 * 功能: 可以单个添加或者批量添加名词解释，对名词解释的删除和新增
 */

<template lang="pug">
  div
    report-nav(:mainId="mainId" :title="title" :kind="kind")
    div(style="max-width: 960px;min-width: 640px;margin: 20px auto;")
      el-tabs(type="border-card" class="abow_dialog" tab-position="top" )
        el-tab-pane(label="单个增加")
          el-form
            el-form-item(label=""  label-width="0px")
              el-col(:span="6")
                el-input(:size="GLOBAL.SIZE_OF_INPUTBOX" auto-complete="off" placeholder="请输入名词"  v-model="glossary")
              el-col(:span="1" style="text-align:center") :
              el-col(:span="14")
                el-input(type="textarea" auto-complete="off" placeholder="请输入解释" :rows="3" v-model="explanation"  @keyup.enter.native="addSingleGlossary()")
              el-button(:size="GLOBAL.SIZE_OF_INPUTBOX"  type="primary" style="float:right;" @click="addSingleGlossary()" :disabled="checkInput()") 添加

        el-tab-pane(label="批量增加")
          el-form
            el-form-item(label=""  label-width="0px")
              el-col(:span="21")
                el-input(type="textarea"  :rows="3" placeholder="请输入内容" v-model="textarea")
              el-button(type="primary" style="float:right;" @click="addBatchGlossary()" :disabled="checkTextarea()" :size="GLOBAL.SIZE_OF_INPUTBOX") 添加
      el-tabs
        el-form(v-for="(glossary,index) in briefGlossarys"  :key="glossary._id")
          el-form-item(label=""  label-width="0px")
            el-col(:span="1")
              el-checkbox(v-model="glossary.checked")
            el-col(:span="6")
              el-input(:size="GLOBAL.SIZE_OF_INPUTBOX" auto-complete="off" @blur="updateGlossary(briefGlossarys,index)"  v-model="glossary.noun")
            el-col(:span="1" style="text-align:center") :
            el-col(:span="16")
              el-input(:size="GLOBAL.SIZE_OF_INPUTBOX" type="textarea" auto-complete="off" @blur="updateGlossary(briefGlossarys,index)" v-model="glossary.explanation")
        el-button(type="danger" style="float:left;" :disabled="hasChecked(briefGlossarys)" @click="deleteGlossary(briefGlossarys)" :size="GLOBAL.SIZE_OF_INPUTBOX") 删除
</template>

<script>
import ReportNav from './components/reportNav'
import Glossary from '../../apis/glossary'
import api from '@/apis/brief'
export default {
  name: 'glossary',
  components: { ReportNav },

  created () {
    this.mainId = this.$route.query.id
    this.briefId = this.$route.query.id
    this.getGlossarys()
    this.title = localStorage.title
    this.kind = localStorage.kind
    api.getBrief({ id: this.mainId }).then(res => {
      this.status = res.data.status
    })
  },
  data () {
    return {
      kind: 0,
      dialogFormVisible: false,
      briefId: '',
      glossary: '',
      explanation: '',
      textarea: '',
      isChecked: true,
      briefGlossarys: [],
      title: '',
      status: ''
    }
  },
  methods: {
    // 检测是否能够删除名词解释
    hasChecked (arr) {
      if (this.status >= 1) {
        return true
      }
      return arr.length === 0 || arr.findIndex(b => b.checked === true) < 0
    },
    // 获取名词解释
    getGlossarys () {
      const where = {
        brief: this.briefId
      }
      Glossary.getGlossaryByBriefId(where).then(r => {
        this.briefGlossarys = r.data
        this.glossary = ''
        this.explanation = ''
      })
    },
    // 添加单个的名词解释
    addSingleGlossary () {
      if (this.checkInput()) {
        return
      }
      const data = {
        brief: this.briefId,
        glossary: [{ noun: this.glossary, explanation: this.explanation }]
      }
      Glossary.addGlossary(data).then(r => {
        if (r) {
          this.$message({
            message: '已添加',
            type: 'success'
          })
          this.glossary = ''
          this.explanation = ''
          this.getGlossarys()
        }
      })
    },
    // 批量添加名词解释
    addBatchGlossary () {
      // 批量增加
      const a = this.textarea.split('\n')
      const glossarydata = []
      // eslint-disable-next-line no-useless-escape
      const patrn = /[\ |\s*(.*?)\s+$|\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\，|\。|\“|\”|\‘|\’|\¥|\？|\（|\）|\；|\：|\、|\！|\<|\.|\>|\/|\?]/i

      for (var i = 0; i < a.length; i++) {
        const glossary = a[i]
        glossary.replace(patrn, function (sub, index) {
          const x = glossary.indexOf(':')
          const y = glossary.indexOf('：')
          // console.log(sub)
          if ((x > 0 || y > 0) && (sub !== ':' || sub !== '：')) {
            if (x > 0 && y > 0) {
              const z = Math.min(x, y)
              const obj = {
                noun: glossary.substring(0, z),
                explanation: glossary.substring(z + 1) // 以 : ：中较前的分割
              }
              glossarydata.push(obj)
            } else {
              if (x > 0) {
                const obj = {
                  noun: glossary.substring(0, x),
                  explanation: glossary.substring(x + 1) // 以 : 分割
                }
                glossarydata.push(obj)
              } else {
                const obj = {
                  noun: glossary.substring(0, y),
                  explanation: glossary.substring(y + 1) // 以 ： 分割
                }
                glossarydata.push(obj)
              }
            }
          } else {
            const obj = {
              noun: glossary.substring(0, index),
              explanation: glossary.substring(index + 1) // 以非 ：:的第一个其他特殊字符分割
            }
            glossarydata.push(obj)
          }
        })
      }
      const data = {
        brief: this.briefId,
        glossary: glossarydata
      }
      Glossary.addGlossary(data).then(r => {
        if (r) {
          this.$message({
            message: '已添加',
            type: 'success'
          })
          this.textarea = ''
        }
        this.getGlossarys()
      })
      // console.log(data)
    },
    // 更新名词解释
    updateGlossary (arr, index) {
      const Glossarydata = arr[index]
      // console.log(Glossarydata)
      Glossary.saveGlossary(Glossarydata).then(r => {
        if (r) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getGlossarys()
        }
      })
    },
    // 删除名词解释
    deleteGlossary (arr) {
      const ids = []
      arr.map(glossary => {
        if (glossary.checked === true) ids.push(glossary._id)
      })
      Glossary.deleteGlossarys(ids).then(r => {
        if (r) {
          this.$message({
            message: '已删除',
            type: 'success'
          })
          this.getGlossarys()
        }
      })
    },
    show () {
      this.dialogFormVisible = true
    },
    // 检测录入单个名词解释表单数据内容是否合法
    checkInput () {
      if (this.status >= 1) {
        return true
      }
      return this.glossary === '' || this.explanation === ''
    },
    // 检测录入批量名词解释数据表单是否合法
    checkTextarea () {
      if (this.status >= 1) {
        return true
      }
      return this.textarea === ''
    }

  }
}
</script>
